class GeoLocationService {

  getCurrentLocation = (options) => {
    const defaultOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 1000 * 60 * 5 // 5 min
    }

    options = { ...defaultOptions, ...options }

    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, options)
    })
  }
}

export default new GeoLocationService()
